import React, { useState, useEffect, useRef } from "react";
import "./Pricing.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
const pricingData = [
    {
        title: "PERSONAL",
        price: "49.99",
        features: [
            { text: "Scheduled servicing", included: true },
            { text: "Component wear reminders", included: true },
            { text: "Introduce new revenue streams", included: true },
            { text: "All routine maintenance", included: true },
            { text: "24/7 customer service", included: true },
        ],
    },
    {
        title: "PROFESSIONAL",
        price: "99.99",
        features: [
            { text: "Scheduled servicing", included: true },
            { text: "Component wear reminders", included: true },
            { text: "Introduce new revenue streams", included: true },
            { text: "All routine maintenance", included: true },
            { text: "24/7 customer service", included: true },
        ],
    },
    {
        title: "PROFESSIONAL",
        price: "99.99",
        features: [
            { text: "Scheduled servicing", included: true },
            { text: "Component wear reminders", included: true },
            { text: "Introduce new revenue streams", included: true },
            { text: "All routine maintenance", included: true },
            { text: "24/7 customer service", included: true },
        ],
    },

];

const Pricing = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null)
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const scrollToSection = () => {
            const { scrollTo } = location.state || {};
            if (scrollTo) {
                const section = document.getElementById(scrollTo);
                if (section) {
                    const yOffset = -210;
                    const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
                // Clear state after scrolling
                window.history.replaceState({}, document.title);
            }
        };

        // Delay slightly to ensure DOM is ready
        const timer = setTimeout(scrollToSection, 50);
        return () => clearTimeout(timer);
    }, [location.state]);
    useEffect(() => {
        // Replace with your API endpoint
        const fetchData = async () => {
            try {
                const response = await fetch('https://admin.ezerautomotive.co.nz/api/plans/');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                setData(result);
                console.log(result, "result")
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);
    console.log(data, "price")
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    return (

        <div id='packages' className="pricing-section">

            <div className="headers-details">
                <div className="pricing-headers">
                    <h2>
                        AFFORDABLE <br /> PRICING PLANS
                    </h2>
                    <p>
                        We provide the best car service, recommend the best products through
                        an independent review process.
                    </p>
                </div>
                <br />

                <ul className="details-list">
                    <li>
                        <span className="orange-square"></span> SAME DAY SERVICE
                    </li>
                    <li>
                        <span className="orange-square"></span> CONVENIENT LOCATION
                    </li>
                    <li>
                        <span className="orange-square"></span> ONLINE APPOINTMENT
                    </li>
                </ul>
                <div className="navigation-buttons">
                    <button ref={prevRef} className="nav-button">
                        <span>&lt;</span>
                    </button>
                    <button ref={nextRef} className=" nav-button">
                        <span>&gt;</span>
                    </button>
                </div>
            </div>

            <div className="pricing-cards-scroll">
                {/* <div className="swiper-button-prev nav-button" />
            <div className="swiper-button-next nav-button" /> */}

                <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                    }}

                    spaceBetween={10}
                    slidesPerView={1}
                    breakpoints={{
                        640: { slidesPerView: 1.5 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 }
                    }}
                    autoplay={{
                        delay: 1500, // auto slide after 3 seconds
                        disableOnInteraction: false, // keep auto sliding after user interaction
                    }}

                >
                    {data.map((plan, index) => (
                        <SwiperSlide key={index}>
                            <div className="pack-container">
                                <div className="cardHeading">
                                    <p className="title">{plan.name}</p>
                                    {/* <div className="price-container">
                                        <span className="frequency">{plan.per_month_or_week}</span>
                                        <span>$</span>{plan.amount}
                                    </div> */}
                                    <div className="price-container">
                                        {plan.per_month_or_week !== "." && (
                                            <span className="frequency">{plan.per_month_or_week}</span>
                                        )}
                                        <span>$</span>{plan.amount}
                                    </div>
                                </div>
                                <ul className="lists">
                                    {[plan.field1, plan.field2, plan.field3, plan.field4, plan.field5].map((field, i) => (
                                        <li className="list" key={i}>
                                            <span>
                                                <svg aria-hidden="true" stroke="currentColor" strokeWidth="5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4.5 12.75l6 6 9-13.5" strokeLinejoin="round" strokeLinecap="round" />
                                                </svg>
                                            </span>
                                            <p>{field}</p>
                                        </li>
                                    ))}
                                </ul>
                                <div className="button-container">
                                    <button type="button" onClick={() => window.open('https://booking.auxosoftware.com/w+WbahyJ_ES6NxDj+gBwFA==', '_blank')}>Buy Now</button>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}

                    {/* Navigation Buttons */}

                </Swiper>
            </div>



        </div>

    );
};

export default Pricing;
